<app-complex-modal-template
    [canConfirm]="!!(selectedOpticalFiberOption() && !!formGroup().controls.distance.value)"
    [stepNumber]="2"
    [title]="'locateBreaks' | transloco"
    [(currentStep)]="currentStep"
    (onClickEvent)="closeModal($event)">
    @switch (currentStep()) {
        @case (1) {
            <div class="pl-6 pt-4 pb-2">
                <span>{{ 'breakDirection' | transloco }}</span>
                <div class="w-3/5">
                    <app-select
                        [canClear]="false"
                        [defaultValue]="defaultBreakDirectionOption"
                        [(options)]="breakDirectionOption"
                        (optionSelected)="selectBreakDirection($event)" />
                </div>

                <div class="py-4">
                    <span>{{ 'fiberSelection' | transloco }}</span>
                    <div class="w-10/12">
                        <app-select-fiber
                            placeholder="selectAFiber"
                            [(options)]="currentOpticalFibersOption"
                            [(selectedOption)]="selectedOpticalFiberOption"
                            (optionSelected)="selectOpticalFiber($event)" />
                    </div>
                </div>

                @if (selectedOpticalFiberOption()) {
                    <span>{{ 'distanceField' | transloco }}</span>
                    <form
                        class="pt-4"
                        [formGroup]="formGroup()">
                        <mat-form-field
                            appearance="outline"
                            class="text-sm">
                            <input
                                formControlName="distance"
                                matInput
                                type="number"
                                [placeholder]="'0.0 m'" />
                        </mat-form-field>
                    </form>
                }
            </div>
        }
        @case (2) {
            <div class="flex items-center justify-center">
                @if (isLoading()) {
                    <app-loading />
                } @else if (breakInformation()) {
                    <span>
                        {{
                            'breakFound'
                                | transloco
                                    : {
                                          distance: breakInformation()!.distance_from_entity | number: '1.2-2',
                                          label: breakInformation()!.etiquette,
                                          graceCode: breakInformation()!.code_gracethd,
                                      }
                        }}</span
                    >
                } @else {
                    <span>{{ 'noBreakFound' | transloco }}</span>
                }
            </div>
        }
    }
</app-complex-modal-template>
